const accordionComponents = (gsap, scrollTrigger, smoother) => {
	
	var keys = {37: 1, 38: 1, 39: 1, 40: 1};

	function preventDefault(e) {
		e.preventDefault();
	}
	
	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventDefault(e);
			return false;
		}
	}

	// modern Chrome requires { passive: false } when adding event
	var supportsPassive = false;
	try {
		window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
			get: function () { supportsPassive = true; } 
		}));
	} catch(e) {}

	var wheelOpt = supportsPassive ? { passive: false } : false;
	var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

	// call this to Disable
	function disableScroll() {
		window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
		window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
		window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
		window.addEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	// call this to Enable
	function enableScroll() {
		window.removeEventListener('DOMMouseScroll', preventDefault, false);
		window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
		window.removeEventListener('touchmove', preventDefault, wheelOpt);
		window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
	}
	
	const $accordions = $('.accordion-btn');

	if ( $accordions.length ) {

		const $closedaccordion = $('.accordion-btn:not(.active)');

		$closedaccordion.on('click', function() {
			gsap.killTweensOf(".expand");

			const close = $('.accordion-btn.active'),
						collapse = $('.expand'),
						icn = $('.accordion-icon'),
						box = $('.accordion-box'),
						$clicked = $(this),
						$parent = $clicked.parent(),
						$expand = $clicked.next('.expand'),
						$minus = $clicked.find('.accordion-icon');
						
						
			let totalHeight = 0,
					duration = 0.4;


			if ( $clicked.hasClass('active') ) {
				
				disableScroll()

				$clicked.add($expand).add($minus).add($parent).removeClass('active');
				gsap.to($expand, {height: 0, duration: 0.6, ease: 'circ.out', onComplete: function() {
					scrollTrigger.refresh();
					enableScroll();
				}});

			} else {
				
				disableScroll()

				//close.add(collapse).add(icn).add(masks).removeClass('active');
				close.add(collapse).add(icn).add(box).removeClass('active');
				gsap.to(collapse, {height: 0, duration: 0.3, ease: 'circ.out', onComplete: function() {

					$expand.children().each(function(){
						totalHeight = totalHeight + $(this).outerHeight(true);
					});
					totalHeight += ($expand.children('ul, ol').length * 15);

					if ( totalHeight <= 98 ) {
						duration = 0.5;
					} else if ( totalHeight > 98 && totalHeight < 118 ) {
						duration = 0.6;
					} else {
						duration = 0.4;
					}

					gsap.to($expand, {height: totalHeight, duration: duration, ease: 'circ.out', autoRound: false, onComplete: function() {
						scrollTrigger.refresh();
						enableScroll();
					}});
					$clicked.add($expand).add($minus).add($parent).addClass('active');

				}});

			}

		});

	}
		
}

export {
	accordionComponents
};
